(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

require("./components/animation-framework");

require("./components/navigation");

require("./components/scroll");

},{"./components/animation-framework":2,"./components/navigation":3,"./components/scroll":4}],2:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

(function () {
  window.addEventListener("DOMContentLoaded", function () {
    var AtomEngine = /*#__PURE__*/function () {
      function AtomEngine() {
        _classCallCheck(this, AtomEngine);

        this.elements = document.querySelectorAll('.atom-animation');
      }

      _createClass(AtomEngine, [{
        key: "init",
        value: function init() {
          var _this = this;

          if (this.elements == undefined) return;
          this.elements.forEach(function (element) {
            _this.constructAnimation(element);
          });
        }
      }, {
        key: "constructAnimation",
        value: function constructAnimation(element) {
          var duration = 0.7;
          var autoAlpha = 0;
          var animation = gsap.timeline({
            reversed: true,
            scrollTrigger: {
              trigger: element,
              toggleActions: "restart reverse restart reverse",
              start: '0 80%'
            }
          });

          if (element.classList.contains('atom--scale-in')) {
            animation.from(element, {
              duration: duration,
              scale: 0,
              autoAlpha: autoAlpha,
              ease: Back.easeOut.config(2)
            });
          }
        }
      }]);

      return AtomEngine;
    }();

    var atomAnimations = document.querySelectorAll('.atom-animation');
    if (atomAnimations !== null) new AtomEngine().init();
  });
})();

},{}],3:[function(require,module,exports){
"use strict";

(function () {
  window.addEventListener('DOMContentLoaded', function (e) {
    var navigationMenu = document.querySelector('.site-header__navigation');
    if (navigationMenu === undefined || navigationMenu === null) return; // store all navigation variables if navigation menu present

    var hamburger = document.querySelector('.site-header__menu-toggle'),
        masthead = document.querySelector('.site-header'),
        siteWrapper = document.querySelector('.site-wrapper'),
        // sticky = masthead.classList.contains('site-header--sticky') ? true : false,
    sticky = true,
        menuItems = masthead.querySelectorAll('.menu-item'),
        windowHash = window.location.hash;
    menuItems.forEach(function (menuItem) {
      var link = menuItem.querySelector('a'),
          hash = link.hash;
      if (hash === '') return;
      /**
       * If the element doesn't exist then don't alter the behaviour
       */

      if (document.querySelector(hash) == null) return;
      e.preventDefault();
    });
    menuItems.forEach(function (menuItem) {
      menuItem.addEventListener('click', function (e) {
        if (window.innerWidth > 1024) return;
        masthead.classList.toggle('site-header--menu-toggle');
      });
    });
    /**
     * Toggle mobile menu icon and navigation menu
     */

    hamburger.addEventListener('click', function (e) {
      return masthead.classList.toggle('site-header--menu-toggle');
    });
    /**
     * Sticky navigation stuff
     */

    var menuOffset = masthead.offsetTop + masthead.clientHeight;

    var stick = function stick() {
      if (window.scrollY >= menuOffset) {
        masthead.classList.add('site-header--sticky--height');
      } else {
        masthead.classList.remove('site-header--sticky--height');
      }
    };

    if (sticky) {
      window.addEventListener('scroll', stick);
    }
  });
})();

},{}],4:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

(function () {
  window.addEventListener('DOMContentLoaded', function () {
    var Scroll = /*#__PURE__*/function () {
      function Scroll(params) {
        _classCallCheck(this, Scroll);

        this.triggers = params.items;
      }

      _createClass(Scroll, [{
        key: "init",
        value: function init() {
          var _this = this;

          if (this.triggers == undefined) return;
          this.triggers.forEach(function (trigger) {
            _this.constructScroller(trigger);
          });
        }
      }, {
        key: "constructScroller",
        value: function constructScroller(trigger) {
          var hash = trigger.hash;
          var section = document.getElementById(hash.replace('#', ''));
          if (section == null) return;
          trigger.addEventListener('click', function (e) {
            e.preventDefault();
            gsap.to(window, {
              duration: 0.75,
              scrollTo: {
                y: section,
                offsetY: 100
              },
              onComplete: function onComplete() {// window.location.hash = hash;
              }
            });
          });
        }
      }]);

      return Scroll;
    }();

    var navLinks = document.querySelectorAll('.menu-item a');
    var buttonLinks = document.querySelectorAll('.buttons__button .scroll-to');
    if (buttonLinks !== null) new Scroll({
      items: buttonLinks
    }).init();
    if (navLinks !== null) new Scroll({
      items: navLinks
    }).init();
  });
})();

},{}]},{},[1]);
